import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";

import { HttpErrorResponse, HttpParams } from "@angular/common/http";
import { HttpClient } from "@angular/common/http";
import { PromiseResult } from "../models/PromiseResult";
import { RestApi } from "../shared/apiUrls";
import { catchError } from "rxjs/operators";

@Injectable({
    providedIn: "root",
})
export class SpecialityService {
    constructor(private readonly http: HttpClient) { }

    private handleError(error: HttpErrorResponse) {
        return throwError(error);
    }

    GetAllSpecialities(has_doctors?: boolean,provider_id?:string): Observable<PromiseResult> {
        let params = new HttpParams();
        params = params.append("has_doctors", Boolean(has_doctors).valueOf().toString())
        if (provider_id) 
            params = params.append("provider_id", provider_id);
        return this.http
            .get<PromiseResult>(RestApi.Urls.SpecialityApi + "GetAll", { params })
            .pipe(catchError(this.handleError));
    }

    GetAllSupported(common_health_id?: number,provider_id?:string): Observable<PromiseResult> {
        let params = new HttpParams();
        if (common_health_id) 
            params = params.append("common_health_id", common_health_id.toString());
        if (provider_id) 
            params = params.append("provider_id", provider_id);
        return this.http
            .get<PromiseResult>(RestApi.Urls.SpecialityApi + "GetAllSupported", { params })
            .pipe(catchError(this.handleError));
    }

    GetAllSupportedPatient(patient_guid: string,common_health_id?: number,provider_id?: string): Observable<PromiseResult> {
        let params = new HttpParams();
        params= params.append("patient_guid", patient_guid);
        if (common_health_id) 
            params = params.append("common_health_id", common_health_id.toString());
        if (provider_id) 
            params = params.append("provider_id", provider_id);
        return this.http
            .get<PromiseResult>(RestApi.Urls.SpecialityApi + "GetAllSupported/Patient", { params })
            .pipe(catchError(this.handleError));
    }

    GetFeaturedSpecialitiesDB(provider_id: string): Observable<PromiseResult> {
        let params = new HttpParams();
        params= params.append("provider_id", provider_id);
        return this.http
            .get<PromiseResult>(RestApi.Urls.SpecialityApi + "GetFeatured", { params })
            .pipe(catchError(this.handleError));
    }


    CreateNewSpeciality(form: FormData): Observable<PromiseResult> {
        return this.http
            .post<PromiseResult>(RestApi.Urls.SpecialityApi + "Create", form)
            .pipe(catchError(this.handleError));
    }
    UpdateSpeciality(
        speciality_id: number,
        form: FormData
    ): Observable<PromiseResult> {
        return this.http
            .put<PromiseResult>(
                RestApi.Urls.SpecialityApi + "Update/" + speciality_id,
                form
            )
            .pipe(catchError(this.handleError));
    }
    DeleteSpeciality(speciality_id: number): Observable<PromiseResult> {
        return this.http
            .delete<PromiseResult>(
                RestApi.Urls.SpecialityApi + "Delete/" + speciality_id
            )
            .pipe(catchError(this.handleError));
    }
}
